export default __webpack_public_path__ + "static/Calibre-Medium-568dce56f869a519a015d3b69443b067.woff2";